import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppData } from '@shared/models/appdata.model';
import { Feedback } from '@core/models/feedback.model';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  apiUrl = this.appData.apiUrl + '/api/v1';

  postFeedback(feedback: Feedback) {
    const url = `${this.apiUrl}/feedback/post-feedback`;
    return this.http.post(url, feedback);
  }
}
